import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { FaGoogle, FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutPage = () => {
    // Japanese names aur dummy images (Homepage testimonials)
    const reviews = [
        { name: "Tanaka Kenji", text: "Nice service", date: "5 months ago", img: "/j1.jpg" },
        { name: "Sato Haruka", text: "Raj Kuruma is a very good service company. I booked a package...", date: "5 months ago", img: "/j2.jpg" },
        { name: "Suzuki Hiroshi", text: "Thanks a lot to Raju san, my experience in India was great...", date: "5 months ago", img: "/j3.jpg" },
        { name: "Takahashi Yuki", text: "Very nice company and good services", date: "5 months ago", img: "/j4.jpg" },
        { name: "Watanabe Akiko", text: "Very good service", date: "5 months ago", img: "/j5.jpg" },
        { name: "Ito Daiki", text: "Nice", date: "5 months ago", img: "/j6.jpg" }
    ];

    return (
        // Added overflow-x-hidden to prevent horizontal scroll on mobile
        <div className="bg-gray-50 overflow-x-hidden">
            <Navbar />

            {/* Banner Section - Height reduced for mobile */}
            <motion.div
                initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                className="relative h-[300px] md:h-[450px] w-full bg-cover bg-center flex items-center justify-center text-white"
                style={{ backgroundImage: "url('/about-banner.jpg')" }}
            >
                <div className="absolute inset-0 bg-black/50" />
                <motion.h1
                    initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
                    className="relative text-4xl md:text-6xl font-bold z-10"
                >
                    About Us
                </motion.h1>
            </motion.div>

            {/* Content Section */}
            <div className="max-w-7xl mx-auto px-6 py-12 md:py-20 grid md:grid-cols-2 gap-12 md:gap-16 items-center">

                {/* Animated Image Section - Responsive adjustments */}
                <div className="relative mb-16 md:mb-0">
                    <motion.img
                        initial={{ scale: 0.9, opacity: 0 }}
                        whileInView={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        src="/about-main.jpg"
                        alt="About Main"
                        className="rounded-2xl shadow-2xl w-full"
                    />

                    {/* Mobile par absolute positioning ko thoda adjust kiya gaya hai */}
                    <motion.img
                        initial={{ x: 50, y: 50, opacity: 0 }}
                        whileInView={{ x: 0, y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        src="/about-small.jpg"
                        alt="About Small"
                        className="absolute -bottom-10 md:-bottom-16 -right-4 md:-right-8 w-40 md:w-72 rounded-xl shadow-2xl border-4 border-white"
                    />
                </div>

                {/* Content Section */}
                <motion.div
                    initial={{ x: 50, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.8 }}
                >
                    <h2 className="text-[#f15a24] font-black text-lg md:text-xl uppercase tracking-widest mb-2 drop-shadow-sm">Trusted Business & Mobility Partner</h2>
                    <h3 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight leading-tight">About Raj Kuruma Enterprises</h3>
                    <p className="text-gray-600 leading-relaxed mb-6">
                        Raj Kuruma Enterprises Pvt. Ltd. is a trusted service provider offering professional car rental, real estate, and business setup solutions across India.
                        With years of experience and a strong nationwide network, we deliver reliable, safe, and efficient services.
                    </p>
                    <p className="text-gray-600 leading-relaxed mb-8">
                        We specialize in transportation, property leasing, and business support, ensuring smooth operations for all our clients.
                    </p>

                    <div className="grid grid-cols-2 gap-4 md:gap-8 border-t pt-8">
                        <div className="hover:scale-105 transition-transform duration-300">
                            <p className="text-3xl md:text-4xl font-bold text-[#1a2b4d]">20+ Years</p>
                            <p className="text-sm text-gray-500 mt-2">Delivering excellence in mobility and business solutions.</p>
                        </div>
                        <div className="hover:scale-105 transition-transform duration-300">
                            <p className="text-3xl md:text-4xl font-bold text-[#1a2b4d]">End-to-End</p>
                            <p className="text-sm text-gray-500 mt-2">Professional support from consultation to execution.</p>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* Testimonials Section (Swiper Carousels added) */}
            <section className="py-20 bg-gray-50 border-t border-gray-100">
                <div className="max-w-7xl mx-auto px-6">
                    {/* Section title */}
                    <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-12">What customer say about Our services</h2>

                    <Swiper
                        modules={[Autoplay, Navigation]}
                        spaceBetween={20}
                        slidesPerView={1}
                        breakpoints={{ 768: { slidesPerView: 3 } }}
                        loop={true}
                        navigation={true}
                        autoplay={{ delay: 3000 }}
                    >
                        {reviews.map((rev, index) => (
                            <SwiperSlide key={index}>
                                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-64 flex flex-col justify-between">
                                    {/* Top part with name and icon */}
                                    <div className="flex justify-between items-start">
                                        <div className="flex items-center gap-3">
                                            <img src={rev.img} alt={rev.name} className="w-10 h-10 rounded-full object-cover" />
                                            <div>
                                                <h4 className="font-bold text-sm">{rev.name}</h4>
                                                <p className="text-xs text-gray-400">{rev.date}</p>
                                            </div>
                                        </div>
                                        <FaGoogle className="text-blue-500" />
                                    </div>

                                    {/* Star ratings */}
                                    <div className="flex text-yellow-400 text-xs my-2">
                                        {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                                    </div>

                                    {/* Review text */}
                                    <p className="text-gray-600 text-sm italic">{rev.text}</p>

                                    {/* Read more button */}
                                    <button className="text-gray-400 text-xs text-left hover:underline">Read more</button>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Verification badge */}
                    <div className="text-center mt-10">
                        <span className="bg-[#0b6623] text-white px-4 py-2 rounded text-sm font-bold flex items-center justify-center gap-2 w-max mx-auto">
                            Verified by Trustindex <span className="text-xs">ⓘ</span>
                        </span>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default AboutPage;